export enum DocsTab {
  HowItWorks,
  ViewExamples,
  DevelopersSection
}